import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ userData, onLogout }) => {
  const navigate = useNavigate();
  return (
    <div className="sidebar">
      {/* Brand / Logo Area */}

      {/* Logo Section (Moved to top) */}
      <div className="avatar-circle" style={{background: 'transparent', border: 'none', boxShadow: 'none', marginBottom: '20px'}}>
        <img 
          src={process.env.PUBLIC_URL + '/Wisdom-Logo.png'} 
          alt="Wisdom Logo" 
          style={{width: '100%', height: '100%', objectFit: 'contain'}}
        />
      </div>
 
      {/* Total Score */}
      <div className="score-card">
        <div className="score-label">Total Score</div>
        <div className="score-value">{userData?.score || 0} Points</div>
      </div>

      {/* Action Buttons */}
      <div className="sidebar-actions">
        <button className="game-button green-btn" onClick={() => navigate('/leaderboard')}>Leaderboard</button>
        <button className="game-button red-btn" onClick={onLogout}>Logout</button>
      </div>

      {/* User Info (Login as...) */}
      <div className="user-info" style={{marginTop: '20px'}}>
        <h3 className="username">Login as : {userData?.username || 'Guest'}</h3>
      </div>

    </div>
  );
};

export default Sidebar;
